module.exports = __webpack_public_path__ + "static/media/dongyanshan_package.9ed8de13.webp";